export default __webpack_public_path__ + "static/media/Prologue_AuroraM2.a93a8c08.svg";